import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { useMuiTheme } from 'themes/themeMuiProvider';

interface HeaderTextProps {
  headerText: string;
  subheaderText?: string;
  highlightedSubheaderText?: string;
}

export const HeaderText: FC<HeaderTextProps> = ({ headerText, subheaderText, highlightedSubheaderText }) => {
  const themeMui = useMuiTheme();

  return (
    <Box>
      <Typography
        variant='h1'
        sx={{
          mt: { xs: 4, md: 8 },
          mb: 4,
          fontSize: {
            xs: 52,
            md: 72,
          },
          textAlign: 'center',
        }}
      >
        {headerText}
      </Typography>

      {subheaderText && (
        <Typography variant='h2' textAlign='center' sx={{ mt: 1.5 }}>
          {subheaderText && subheaderText}
        </Typography>
      )}

      {highlightedSubheaderText && (
        <Typography variant='h4' textAlign='center' sx={{ mt: 1.5 }}>
          <Box component='span' color={themeMui.colors.blue}>
            {highlightedSubheaderText}
          </Box>
        </Typography>
      )}
    </Box>
  );
};
